export const API = {
  POSTTitleListData: "title_list/fetchTitles",
  FETCHSEASON: "title_list/fetchSeasons",
  FETCHDIVISION: "title_list/fetchDivision",
  FETCHIMPRINTS: "title_list/fetchImprints",
  FETCHFORMAT: "title_list/fetchFormat",
  ADDUSER: "/user/addUser",
  FETCHUSERS: "/user/fetchUsers",
  fetchUserInfo: "/user/fetchUserInfo",
  LOGINUSER: "/user/loginUser",
  DOWNLOAD_TITLES: "/title_list/download-excel",
  // LOGINUSER: "/user/azure-local-token",
  LOGOUTUSER: "/user/logoutUser",
  FETCHISBNSLIST: "title_list/fetchIsbns",
  FETCHACCOUNTS: "accounts/fetchAccounts",
  FETCHEANSLIST: "ean/fetchEansList",
  FETCHDETAILSRECORD: "title_list/fetchSelectedTitle",
  DOWNLOADPDF: "title_list/DownloadPdf",
  FetchManagingEditor: "title_list/FetchManagingEditor",
  FetchEditor: "title_list/FetchEditor",
  FetchBisacStatus: "title_list/FetchBisacStatus",
  FetchAuthor1: "title_list/FetchAuthor1",
  FETCHLICENSOR: "title_list/fetchLicensor",
  FETCHSERIES: "title_list/fetchSeries",
  TITLESALESDATA: "title_sales/fetchTitleGrossSales",
  YTDTITLESALESDATA: "title_sales/fetchTitleYTDGrossSales",
  MTDTITLESALESDATA: "title_sales/fetchTitleMTDGrossSales",
  LTDTITLESALESDATA: "title_sales/fetchTitleLTDGrossSales",
  BookScanTITLESALESDATA: "title_sales/fetchTitleBookScanGrossSales",
  AmazonTITLESALESDATA: "title_sales/fetchAmazonGrossSales",
  ReaderLinkTITLESALESDATA: "title_sales/fetchTitleReaderLinkGrossSales",
  FetchInventorySales: "title_sales/fetchTitleInventorySales",
  FetchInventorySalesBo: "title_sales/fetchTitleInventorySalesBo",
  fetchBoUnitsDetails: "title_sales/fetchBoUnitsDetails",
  FETCHACCOUNTGROUPSALES: "title_sales/fetchAccountGroupSales",
  FETCH_DISTRIBUTION_SALES: "title_sales/fetchDistributionChannelSales",
  FETCH_REGION_SALES: "title_sales/fetchRegionSales",
  GENERATE_POWERBI_EMBED_TOKEN: "title_sales/generatePowerBIEmbedToken",
  fetchPrintDetails: "title_sales/fetchPrintDetails",
  fetchPrintHistory: "title_sales/fetchPrintHistory",


  RlsApi: "/user/GL-By-email",
  FetchBaseUrl: "/user/FetchBaseUrl",
      checkAuthorization:"title_list/checkAuthorization",
 
  // Inventory Stock Report APIs
  FETCH_INVENTORY_STOCK_REPORT: "inventoryStockReport/fetchTmmExportSmallVersion",
  FETCH_INVENTORY_SEASONS: "inventoryStockReport/fetchInventorySeasons",
  FETCH_INVENTORY_DIVISION: "inventoryStockReport/fetchInventoryDivision",
  FETCH_INVENTORY_IMPRINTS: "inventoryStockReport/fetchInventoryImprints",
  FETCH_INVENTORY_FORMAT: "inventoryStockReport/fetchInventoryFormat",
  FETCH_INVENTORY_MANAGING_EDITOR: "inventoryStockReport/fetchInventoryManagingEditor",
  FETCH_INVENTORY_EDITOR: "inventoryStockReport/fetchInventoryEditor",
  FETCH_INVENTORY_BISAC_STATUS: "inventoryStockReport/fetchInventoryBisacStatus",
  FETCH_INVENTORY_AUTHOR: "inventoryStockReport/fetchInventoryAuthor",
  FETCH_INVENTORY_ISBNS: "inventoryStockReport/fetchInventoryIsbns",
  FETCH_INVENTORY_LICENSOR: "inventoryStockReport/fetchInventoryLicensor",
  FETCH_INVENTORY_SERIES: "inventoryStockReport/fetchInventorySeries",
  FETCH_INVENTORY_DISTRIBUTION_CLIENT: "inventoryStockReport/fetchInventoryDistributionClient",
  EXPORT_INVENTORY_STOCK_REPORT: "inventoryStockReport/exportInventoryStockReport",
 
  // FetchManagingEditor:"title_list/FetchManagingEditor",
  // FetchEditor: "title_list/FetchEditor",
  // FetchBisacStatus: "title_list/FetchBisacStatus",
  // FetchAuthor1: "title_list/FetchAuthor1"
};
 